import React from 'react';
import UserChecklist from './UserChecklist';

const UserChecklistWrapper = ({ email }) => {
  // Simply pass through to UserChecklist - it handles its own data fetching
  return <UserChecklist email={email} />;
};

export default UserChecklistWrapper;
